import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    color: palette.common.white,
    height: '32px',
    fontSize: '13px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    flexShrink: '0',
    lineHeight: '32px',
    marginRight: '10px',
    textAlign: 'center',
    width: '32px'
  },
  collaborator: {
    alignItems: 'center',
    display: 'flex',
    fontFamily: palette.fontFamilies.poppins,
    padding: '12px 0 12px 0',
    '& .MuiSvgIcon-root': {
      marginRight: '6px'
    }
  },
  formContent: {
    padding: '16px 36px 24px',
    overflowY: 'auto',
    flexGrow: '1'
  },
  modalFooter: {
    marginTop: '10px',
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: '100%',
      '& + &': {
        marginTop: '10px',
        marginLeft: '0'
      },
      '& button': {
        width: '100%'
      }
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  form: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  portfoliosRadioGroup: {
    display: 'flex',
    borderBottom: "1px solid ".concat(palette.shades[400]),
    '& .MuiFormControlLabel-root': {
      width: '100%',
      '& .MuiTypography-root': {
        width: '100%'
      }
    }
  }
}));
export default useStyles;